export default {
      id: "telegram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.95404f0a.svg#telegram",
      toString: function () {
        return this.url;
      }
    }